import { render, staticRenderFns } from "./saved_orders_widget.vue?vue&type=template&id=15d7870e&scoped=true&"
import script from "./saved_orders_widget.vue?vue&type=script&lang=js&"
export * from "./saved_orders_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d7870e",
  null
  
)

export default component.exports